import Styled from 'styled-components'

export const DivContentCar = Styled.div`
display: flex;
margin: 20px 0 10px;
justify-content: space-between;
margin-right: 20px;
margin-left: 20px;
    
    .label {
        display: flex;
        color: ${props => props.theme.primary};;
        font-weight: 400;
        font-size: 14px;
        align-items: center;
        margin: 0;
    }
    
    .info {
        text-align: center;
        display: flex;
        flex-direction: column;
    }
    
    .date {
        color: ${props => props.theme.primary};;
        font-weight: 600;
        font-size: 16px;
    }
    
    .local{
            color: rgba(5, 9, 34, 0.6)
            font-weight: 400;
            font-size: 12px;
    }
`
